import { jsx as _jsx } from "react/jsx-runtime";
export const DocumentXs = ({ color = 'currentColor', ...props })=>/*#__PURE__*/ _jsx("svg", {
        fill: "none",
        height: "16",
        viewBox: "0 0 16 16",
        width: "16",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ _jsx("path", {
            d: "M10 1.25C10.1989 1.25 10.3896 1.32914 10.5303 1.46973L13.5303 4.46973C13.6709 4.61038 13.75 4.80109 13.75 5V13C13.75 13.9894 12.9766 14.75 12 14.75H4C3.0336 14.7499 2.25 13.9664 2.25 13V3C2.25 2.04297 3.0107 1.25012 4 1.25H10ZM4 2.75C3.8535 2.75012 3.75 2.85938 3.75 3V13C3.75 13.138 3.86203 13.2499 4 13.25H12C12.1406 13.25 12.25 13.1466 12.25 13V5.75H10C9.58589 5.74988 9.25 5.41414 9.25 5V2.75H4ZM10 10.25C10.4142 10.25 10.75 10.5858 10.75 11C10.75 11.4142 10.4142 11.75 10 11.75H5.5C5.08588 11.7499 4.75 11.4141 4.75 11C4.75 10.5859 5.08588 10.2501 5.5 10.25H10ZM10 7.25C10.4142 7.25 10.75 7.58579 10.75 8C10.75 8.41421 10.4142 8.75 10 8.75H5.5C5.08588 8.74988 4.75 8.41414 4.75 8C4.75 7.58586 5.08588 7.25012 5.5 7.25H10Z",
            fill: color
        })
    });

//# sourceMappingURL=document-xs.js.map